import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/contact.css";
import { Helmet } from "react-helmet";
import urls from "../Utils/urls";

const IcoPhone   = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoMail    = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const IcoWA      = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.557 4.126 1.532 5.864L0 24l6.293-1.506A11.933 11.933 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.371l-.359-.214-3.732.893.924-3.638-.234-.374A9.818 9.818 0 1 1 12 21.818z"/></svg>;
const IcoMapPin  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IcoSend    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor"/></svg>;
const IcoCheck   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoAlert   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IcoClock   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IcoShield  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
const IcoHelp    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;

const OFFICE_ADDRESS = "AG-52, Shalimar Bagh, Delhi - 110088";
const MAP_QUERY = encodeURIComponent("AG-52, Shalimar Bagh, Delhi 110088");

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "", subject: "", message: "", consent: false });
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', text: string }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    // Clear a field's error as soon as the user starts fixing it
    setErrors(prev => (prev[name] ? { ...prev, [name]: undefined } : prev));
    setStatus(null);
  };

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Full name is required";
    else if (!/^[A-Za-z\s]+$/.test(formData.name)) errs.name = "Name should only contain letters";
    if (!formData.email.trim()) errs.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(formData.email.trim())) errs.email = "Enter a valid email address";
    if (!formData.mobile.trim()) errs.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(formData.mobile)) errs.mobile = "Enter a valid 10-digit mobile number";
    if (!formData.subject) errs.subject = "Please select an inquiry type";
    if (!formData.message.trim()) errs.message = "Message is required";
    else if (/^\d+$/.test(formData.message)) errs.message = "Message cannot be numeric only";
    if (!formData.consent) errs.consent = "Please accept the consent to continue";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (processing) return;
    setStatus(null);

    if (!validate()) {
      setStatus({ type: "error", text: "Please correct the highlighted fields and try again." });
      return;
    }

    const payload = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      subject: formData.subject,
      message: formData.message,
    };

    setProcessing(true);
    try {
      const resp = await fetch(`${urls.API_BASEPATH}${urls.payment.SEND_CUSTOMER_QUERY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
        body: JSON.stringify(payload),
      });
      if (resp.status === 200) {
        const dataset = await resp.json();
        if (dataset.status === 1) {
          setStatus({ type: "success", text: "Thank you! Your message has been sent. Our team will get back to you within 24 hours." });
          setFormData({ name: "", email: "", mobile: "", subject: "", message: "", consent: false });
          setErrors({});
        } else {
          setStatus({ type: "error", text: "We couldn't submit your message. Please try again or call us at +91 7042561004." });
        }
      } else {
        setStatus({ type: "error", text: "We couldn't submit your message. Please try again or call us at +91 7042561004." });
      }
    } catch (error) {
      console.error("Error sending Form:", error);
      setStatus({ type: "error", text: "Network error. Please check your connection and try again." });
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Salary Uncle -- We're Here to Help You</title>
        <meta property="og:title" content="Contact Salary Uncle -- We're Here to Help You" />
        <meta name="description" content="Have questions or need support? Contact Salary Uncle via phone, email, or our inquiry form. We're available Mon–Sat, 9 AM–7 PM. Reach us today!" />
        <meta property="og:description" content="Have questions or need support? Contact Salary Uncle via phone, email, or our inquiry form. We're available Mon–Sat, 9 AM–7 PM. Reach us today!" />
        <link rel="canonical" href={`${urls.SITE_URL}/contact`} />
      </Helmet>

      {/* HERO */}
      <section className="ct-hero">
        <div className="ct-hero-inner">
          <span className="ct-tag">CONTACT US</span>
          <h1>We're Here to Help</h1>
          <p>Have questions about your loan? Need help with your application?<br />Our experts are available 7 days a week.</p>
          <div className="ct-hero-meta">
            <span><IcoClock /> Replies within 24 hours</span>
            <span><IcoShield /> Your details stay private</span>
            <span><IcoWA /> WhatsApp support 24/7</span>
          </div>
        </div>
      </section>

      {/* 3 CHANNEL CARDS */}
      <div className="ct-channels">
        <div className="ct-channel-card">
          <div className="ct-ch-icon ct-ch-green"><IcoPhone /></div>
          <h3>Call Us</h3>
          <div className="ct-ch-val">+91 7042561004</div>
          <div className="ct-ch-sub">Mon–Sat: 9 AM – 7 PM</div>
          <a href="tel:+917042561004" className="ct-ch-btn ct-ch-btn-top">Call Now</a>
        </div>
        <div className="ct-channel-card">
          <div className="ct-ch-icon ct-ch-dark"><IcoMail /></div>
          <h3>Email Us</h3>
          <div className="ct-ch-val">Customercare@salaryuncle.com</div>
          <div className="ct-ch-sub">Response within 24 hours</div>
          <a href="mailto:Customercare@salaryuncle.com" className="ct-ch-btn ct-ch-btn-top">Send Email</a>
        </div>
        <div className="ct-channel-card">
          <div className="ct-ch-icon ct-ch-wa"><IcoWA /></div>
          <h3>WhatsApp</h3>
          <div className="ct-ch-val">+91 7428966114</div>
          <div className="ct-ch-sub">Chat 24/7 for instant support</div>
          <a href="https://wa.me/917428966114" className="ct-ch-btn ct-ch-btn-top" target="_blank" rel="noopener noreferrer">Chat Now</a>
        </div>
      </div>

      {/* FORM + SIDEBAR */}
      <section className="ct-body">
        <div className="ct-body-inner">

          {/* FORM */}
          <div className="ct-form-box">
            <h2>Send Us a Message</h2>
            <p className="ct-form-sub">Fill in the form below and our support team will get back to you within one working day.</p>

            <form className="ct-form" onSubmit={handleSubmit} noValidate>
              {status && (
                <div className={`ct-status ct-status-${status.type}`} role="status" aria-live="polite">
                  {status.type === "success" ? <IcoCheck /> : <IcoAlert />}
                  <span>{status.text}</span>
                </div>
              )}

              <div className="ct-form-row">
                <div className="ct-field">
                  <label htmlFor="ct-name">Your Name<span className="ct-req">*</span></label>
                  <input
                    id="ct-name"
                    type="text"
                    name="name"
                    autoComplete="name"
                    placeholder="Enter your full name"
                    className={errors.name ? "ct-invalid" : ""}
                    aria-invalid={!!errors.name}
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <small className="ct-err"><IcoAlert /> {errors.name}</small>}
                </div>
                <div className="ct-field">
                  <label htmlFor="ct-email">Email Address<span className="ct-req">*</span></label>
                  <input
                    id="ct-email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    placeholder="Enter your email"
                    className={errors.email ? "ct-invalid" : ""}
                    aria-invalid={!!errors.email}
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <small className="ct-err"><IcoAlert /> {errors.email}</small>}
                </div>
              </div>

              <div className="ct-form-row">
                <div className="ct-field">
                  <label htmlFor="ct-mobile">Mobile Number<span className="ct-req">*</span></label>
                  <input
                    id="ct-mobile"
                    type="tel"
                    name="mobile"
                    inputMode="numeric"
                    maxLength={10}
                    autoComplete="tel-national"
                    placeholder="10-digit mobile number"
                    className={errors.mobile ? "ct-invalid" : ""}
                    aria-invalid={!!errors.mobile}
                    value={formData.mobile}
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                      handleChange(e);
                    }}
                  />
                  {errors.mobile
                    ? <small className="ct-err"><IcoAlert /> {errors.mobile}</small>
                    : <small className="ct-hint">We'll only use this to respond to your query.</small>}
                </div>
                <div className="ct-field">
                  <label htmlFor="ct-subject">Subject<span className="ct-req">*</span></label>
                  <select
                    id="ct-subject"
                    name="subject"
                    className={errors.subject ? "ct-invalid" : ""}
                    aria-invalid={!!errors.subject}
                    value={formData.subject}
                    onChange={handleChange}
                  >
                    <option value="">Select Subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Customer Support</option>
                    <option value="loan">Loan Assistance</option>
                    <option value="feedback">Feedback</option>
                  </select>
                  {errors.subject && <small className="ct-err"><IcoAlert /> {errors.subject}</small>}
                </div>
              </div>

              <div className="ct-field">
                <label htmlFor="ct-message">Message<span className="ct-req">*</span></label>
                <textarea
                  id="ct-message"
                  name="message"
                  rows="5"
                  placeholder="Describe your query in detail..."
                  className={errors.message ? "ct-invalid" : ""}
                  aria-invalid={!!errors.message}
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && <small className="ct-err"><IcoAlert /> {errors.message}</small>}
              </div>

              <div className="ct-field">
                <div className="ct-checkbox">
                  <input type="checkbox" name="consent" id="consent" checked={formData.consent} onChange={handleChange} aria-invalid={!!errors.consent} />
                  <label htmlFor="consent">I agree to be contacted by <strong>Salary Uncle</strong> for alerts &amp; promotions*</label>
                </div>
                {errors.consent && <small className="ct-err"><IcoAlert /> {errors.consent}</small>}
              </div>

              <button type="submit" className="ct-submit" disabled={processing}>
                {processing
                  ? <><span className="ct-spinner" aria-hidden="true" /> Sending...</>
                  : <><IcoSend /> Send Message</>}
              </button>
            </form>
          </div>

          {/* SIDEBAR */}
          <div className="ct-sidebar">
            <div className="ct-sidebar-card">
              <div className="ct-sb-head"><IcoMapPin /> Our Office</div>
              <p>Registered Office: {OFFICE_ADDRESS}</p>
              <a
                className="ct-map"
                href={`https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open our office location in Google Maps"
              >
                <iframe
                  title="Salary Uncle office location"
                  src={`https://maps.google.com/maps?q=${MAP_QUERY}&z=15&output=embed`}
                  height="170"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
                <div className="ct-map-overlay"><IcoMapPin /> View on Google Maps</div>
              </a>
            </div>

            <div className="ct-sidebar-card">
              <div className="ct-sb-head"><IcoPhone /> Customer Support</div>
              <table className="ct-hours-table">
                <tbody>
                  <tr><td>Monday – Saturday</td><td className="ct-hours-time">9:00 AM – 7:00 PM</td></tr>
                  <tr><td>Sunday</td><td className="ct-hours-time">Emergency only via WhatsApp</td></tr>
                </tbody>
              </table>
              <a href="tel:+917042561004" className="ct-sb-phone"><IcoPhone /> +91 7042561004</a>
            </div>

            {/* Quick answers */}
            <div className="ct-sidebar-card ct-sb-green">
              <div className="ct-sb-head-white"><IcoHelp /> Looking for quick answers?</div>
              <p className="ct-sb-green-p">Eligibility, documents, interest rates and repayment — most questions are already answered in our FAQ.</p>
              <Link to="/faq" className="ct-faq-btn">View FAQs</Link>
            </div>

            {/* Social Media */}
            <div className="ct-sidebar-card">
              <div className="ct-sb-head">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                Connect Us
              </div>
              <div className="ct-social-row">
                <a href="https://www.facebook.com/SalaryUncle" target="_blank" rel="noopener noreferrer" className="ct-social-btn" aria-label="Facebook">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                </a>
                <a href="https://twitter.com/SalaryUncle" target="_blank" rel="noopener noreferrer" className="ct-social-btn" aria-label="Twitter / X">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                </a>
                <a href="https://www.instagram.com/salaryuncle" target="_blank" rel="noopener noreferrer" className="ct-social-btn" aria-label="Instagram">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                </a>
                <a href="https://www.linkedin.com/company/salaryuncle" target="_blank" rel="noopener noreferrer" className="ct-social-btn" aria-label="LinkedIn">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Contact;
